import { Button} from "react-bootstrap";
import ImagePreview from "./ImagePreview";
import { FontAwesomeIcon } from "../../../../../CommonComponents/AssetsHelper";
import { loadLanguage } from "../../../../../../utils";
import { useEffect, useState } from "react";

const PreviewAction = ({ onMouseDown, canvasCursor, canvasRef, onMouseMove, onMouseUp, loading, settingAction, language }) => {

    const [lang, setlang] = useState(null);

    useEffect(() => {
        const fetchLang = async () => {
            const langData = await loadLanguage(language, null);
            setlang(langData);
        };
            const loginOwnerId = localStorage.getItem('ownerId');
            if(loginOwnerId=='181625') fetchLang();
    }, [language]);
    
    return (
        <div className="pb-height-auto f-center flex-wrap border-end h-100">
            <div className="photo_booth_inner w-100 text-center f-center flex-column h-100 pb-height-auto">
                <div className="mb-lg-3 mb-3 fs-5 fw-semibold">{settingAction == 1 ? 'Customization' : 'PhotoBooth'} Preview</div>
                <div className="photo_booth_box position-relative w-100 f-center">
                    <div className="photo_booth_box_inner">
                        <div className={`photo_booth_box_inner_top f-center ${loading ? 'active_blur' : ''}`}>
                            <ImagePreview {...{ canvasRef, canvasCursor, onMouseDown, onMouseMove, onMouseUp }} />
                        </div>
                        <div className="pb_user_buttons">
                            <Button variant="dark" className="f-center w-100 mb-3 py-3">
                                <FontAwesomeIcon type={'regular'} icon={'camera'} iconClass="me-2 fs-4" /> {lang?.Strike_Pose || 'Strike a Pose'} </Button>
                            <Button variant="" className="f-center w-100 btn-outline-secondary py-3">
                                <FontAwesomeIcon type={'regular'} icon={'cloud-arrow-up'} iconClass="me-2 fs-4" /> {lang?.upload_gallery || 'Upload from Gallery'} </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PreviewAction